Vue.component("Case", {
    mixins: [SceneContentComponentMixin],
    template: `
        <transition name="tabContent-entrance">
            <div class="Case__wrapper content__wrapper" v-if="contentReady" >
                <div class="content__left">
                    <div class="button__back button" @click="closeCase">
                        <span>5S hjulet</span>
                    </div>
                    
                    <h3 v-html="title"></h3>
                    <h1 v-html="getStepTitle"></h1>
                    <div class="content__left_text" >
                        <div v-html="getStepText"></div>
                        <TkReader :audio="getStepTextToSpeech"></TkReader>
                    </div>
                </div>

                <div class="content__right">
                    <component v-for="step in computedSteps" @step-completed="stepCompleted" :key="step.id" :is="step.component" :step="step.content[0]" :id="step.id" :imgDirectory="imgDirectory" @overwrite-step-text="setOverwriteTextLeft" @overwrite-step-audio="setOverwriteAudioLeft"></component>

                    <div class="content__right__background" :class="backgroundBlurred">
                        <img :src="imgDirectory + getBackgroundImage">
                    </div>

                    <button class="button__continue button" v-if="showProgressButton || currentStepCompleted" :class="{'button__continue--active': allStepsCompleted || currentStepCompleted}" @click="nextStep">
                        <span>Fortsæt</span>
                    </button>
                </div>
            </div>
        </transition>
    `,
    data() {
        return {
            title: '',
            steps: [],

            processedSteps: [],
            allStepsCompleted: false,
            currentStepCompleted: false,

            overwriteStepText: '',
            audioLeft: null,

            activeStep: 0,
            contentReady: false,
            imgDirectory: config.BACKGROUND_IMAGE_DIRECTORY || '',
        }
    },
    methods: {
        prepareSteps() {
            if (Array.isArray(this.steps)) {
                this.processedSteps = this.steps.map((s, i) => {
                    s.id = i;
                    s.stepCompleted = false;
                    s.component = s.content.length !== 0 ? this.getVueComponent(s) : "CaseStepNone";
                    s.showProgressButton = this.getShowProgressButton(s);
                    return s;
                });
            } else {
                this.steps.id = 0;
                this.steps.component = this.getVueComponent(this.steps)
                this.processedSteps.push(this.steps)
            }
        },
        getVueComponent(step) {
            if (step.content[0].img) {
                return "CaseStepAssignment"
            } else if (step.content[0].slides) {
                return "CaseStepSlides"
            } else if (step.content[0].hotspots) {
                return "CaseStepHotspots"
            } else if (step.content[0].cards) {
                return "CaseStepCards"
            } else if (step.content[0].completedText) {
                return "CaseStepCompleted"
            } else  if (step.content[0].groups) {
                return "CaseStepSort"
            }
        },
        getShowProgressButton(step) {
            if(step.component == 'CaseStepSort') {
                if (step.content[0].groups.length > 1) {
                    return false;
                } else {
                    return true;
                }
            } else if(step.component == 'CaseStepHotspots' || "CaseStepCards") {
                return false;
            } else {
                return true;
            }
        },
        nextStep() {
            if (this.allStepsCompleted) {
                this.saveCompletion();
                this.close();
            } else if (this.processedSteps[this.activeStep].stepCompleted) {
                this.currentStepCompleted = false;
                this.activeStep = this.activeStep + 1;
                this.overwriteStepText = '';
                this.audioLeft = null;
                window.dispatchEvent(new CustomEvent('audio-playing'));
            }
        },

        setOverwriteTextLeft(text) {
            this.overwriteStepText = text;
        },
        setOverwriteAudioLeft(audio) {
            this.audioLeft = audio;
        },

        checkAllStepsCompleted() {
            let completecounter = 0,
                completed = false,
                i = 0;

            while (i < this.processedSteps.length) {
                if (this.processedSteps[i].stepCompleted == true) {
                    completecounter = completecounter + 1;
                }
                i++;
            }

            completed = completecounter === this.processedSteps.length

            return completed;
        },
        stepCompleted(val, id) {
            this.processedSteps[id].stepCompleted = val;
            this.currentStepCompleted = true;
            this.allStepsCompleted = this.checkAllStepsCompleted();
        },
        saveCompletion() {
            if (!app.localStore.get("hotspots-completed").completed)
                app.localStore.set("hotspots-completed", {
                    completed: []
                })


            let array = app.localStore.get("hotspots-completed").completed;
            let isCompleted = false;

            isCompleted = array.find(a => {
                if (a == this.contentId) {
                    return true;
                }
            })

            if (isCompleted === undefined) {
                array.push(this.contentId)
            }

            app.localStore.set("hotspots-completed", {
                completed: array
            })

            this.sendEvent(array);

        },
        sendEvent(array) {
            window.dispatchEvent(new CustomEvent('hotspotcompleted', {detail: array}));
        },
        closeCase() {
            if (this.allStepsCompleted) {
                this.saveCompletion();
            }
            this.close();
        }
    },
    created() {
        this.prepareSteps();
    },
    mounted() {
        this.contentReady = true;
    },
    watch: {
        processedSteps: function (val) {
            setTimeout(() => {
                this.allStepsCompleted = this.checkAllStepsCompleted();
            }, 1);
        }
    },
    computed: {
        computedSteps() {
            return this.processedSteps.filter((step) => {
                if (step.id === this.activeStep) {
                    return step;
                }
            });
        },
        hasMultipleSteps() {
            return this.steps.length > 1;
        },

        onLastStep() {
            let v = false;

            if (!this.hasMultipleSteps) {
                v = true;
            } else if (this.activeStep + 1 === this.steps.length) {
                v = true;
            }

            return v;
        },
        showProgressButton() {
            return this.processedSteps[this.activeStep].showProgressButton;
        },

        getBackgroundImage() {
            return this.computedSteps[0].background ? this.computedSteps[0].background.src : "#8e8e8d";
        },
        backgroundBlurred() {
            return {
                'content__right__background--blur': this.computedSteps[0].blurBackground
            }
        },
        getStepTitle() {
            return this.computedSteps[0].title
        },
        getStepText() {
            return this.overwriteStepText == '' ? this.computedSteps[0].text : this.overwriteStepText;
        },
        getStepTextToSpeech() {
            return this.audioLeft == null ? this.computedSteps[0].textToSpeech : this.audioLeft;
        }
    }
})

/* Assignment */
Vue.component("CaseStepAssignment", {
    props: ["step", "imgDirectory", "id"],
    template: `
        <div class="CaseStepAssignment">
            <img :src="imgDirectory + step.img.src">
            <h2 v-html="step.title"></h2>
            <div v-html="step.subtitle"></div>
            <TkReader :audio="step.textToSpeech"></TkReader>
        </div>
    `,
    mounted() {
        this.completed();
    },
    methods: {
        completed() {
            this.$emit("step-completed", true, this.id)
        }
    }
})

/* Slides */
Vue.component("CaseStepSlides", {
    props: ["step", "imgDirectory", "id"],
    template: `
        <div class="CaseStepSlides">
            <div class="CaseStepSlides__slide" v-for="(slide, i) in slides" :class="getSlideClass(slide)" :key="slide.id">
                <div class="CaseStepSlides__slide__button CaseStepSlides__slide__button_previous" @click="previousSlide"></div>
                <h2 v-html="slide.title !== '' ? step.title : step.finalSlide"></h2>

                <div class="CaseStepSlides__slide__img_wrapper" v-if="slide.image">
                    <img :src="imgDirectory + slide.image.src">
                    <span v-html="slide.title"></span>
                </div>

                <div class="CaseStepSlides__slide__answer_wrapper" v-if="slide.answers.length !== 0">
                    <div v-for="answer in slide.answers" :key="answer.id" :style="getAnswerBackgroundColor(answer.color)" :class="getAnswerClass(answer)" @click="selectAnswer(slide, answer)">
                        <span v-html="answer.text"></span>
                    </div>
                </div>

                <div class="CaseStepSlides__slide__button CaseStepSlides__slide__button_next" @click="nextSlide(slide.completed)" v-if="slide.hasOwnProperty('completed')"></div>
            </div>

            <span class="CaseStepSlides__help">Du har sorteret <strong>{{amountCompleted}} ud af {{slidesToComplete}}</strong> værktøjer</span>
        </div>
    `,
    data() {
        return {
            slides: [],
            activeSlide: 0,
            allAnswered: false,
            amountCompleted: 0,
            slidesToComplete: 0
        }
    },
    created() {
        this.prepareSlides();
    },
    watch: {
        allAnswered: function (val) {
            if (val === true)
                this.$emit("step-completed", val, this.id)
        }
    },
    methods: {
        prepareSlides() {
            this.slides = this.step.slides.map((s, i) => {
                s.id = i;
                s.completed = false;
                return s;
            })

            this.slidesToComplete = this.slides.length;
            this.slides.push(this.getFinalSlide());
        },
        getFinalSlide() {
            let slide = {
                id: this.slides.length,
                answers: [],
                image: null,
                title: ''
            };

            return slide;
        },
        getSlideClass(slide) {
            return {
                //slide animations
                'CaseStepSlides__slide--left': slide.id === this.activeSlide - 1,
                'CaseStepSlides__slide--right': slide.id === this.activeSlide + 1,
                'CaseStepSlides__slide--leftleft': slide.id === this.activeSlide - 2,
                'CaseStepSlides__slide--rightright': slide.id === this.activeSlide + 2,
                'CaseStepSlides__slide--below': slide.id < this.activeSlide - 2,
                'CaseStepSlides__slide--above': slide.id > this.activeSlide + 2,

                //other
                'CaseStepSlides__slide--completed': slide.completed === true,
                'CaseStepSlides__slide--final': slide.hasOwnProperty('completed') === false

            }
        },
        previousSlide() {
            if (this.activeSlide <= 0)
                return


            this.activeSlide = this.activeSlide - 1;
        },
        nextSlide(completed) {
            if (this.activeSlide === this.slides.length - 1 || !completed)
                return


            this.activeSlide = this.activeSlide + 1;
        },

        selectAnswer(slide, answer) {
            slide.completed = true;
            this.allAnswered = this.checkIfAllAnswered();
            this.amountCompleted = this.checkAmountCompleted();

            let i = 0;

            while (i < slide.answers.length) {
                slide.answers[i].selected = false;
                i++;
            }

            answer.selected = true;
            this.$forceUpdate();
        },


        getAnswerBackgroundColor(color) {
            return {
                background: color
            }
        },
        getAnswerClass(answer) {
            return {
                "CaseStepSlides__slide__answer--notselected": answer.selected === false
            }
        },
        checkIfAllAnswered() {
            return this.slides.filter(s => s.completed).length === this.slidesToComplete;
        },
        checkAmountCompleted() {
            return this.slides.filter(s => s.completed).length
        }
    }
})

/* Sort */
Vue.component("CaseStepSort", {
    props: ["step", "imgDirectory", "id"],
    template: `
        <div class="CaseStepSort"> 
            <component is="CaseStepSortGroup" :tools="group.tools" :imgDirectory="imgDirectory" v-for="(group, i) in computedGroups" :key="i" @group-completed="groupCompleted"></component>
            
            <div class="CaseStepSortGroup__feedback" v-if="canProgress">
                <div v-if="feedbackType == true" class="CaseStepSortGroup__feedback_correct" v-html="computedGroups[0].positiveFeedback"></div>
                <div v-else class="CaseStepSortGroup__feedback_incorrect" v-html="computedGroups[0].negativeFeedback"></div>
            </div>
            
            <button class="button__continue button" v-if="!allGroupsDone" :class="{'button__continue--active': canProgress}" @click="progressSort">
                <span v-html="getContinueButtonText"></span>
            </button>
        </div>
    `,
    data() {
        return {
            activeGroup: 0,
            canProgress: false,
            feedbackType: null
        }
    },
    created() {
    },
    methods: {
        groupCompleted(correct) {
            this.feedbackType = correct;
            this.canProgress = true;
        },
        progressSort () {
            if(this.canProgress) {
                this.feedbackType = null;
                this.activeGroup++;
                this.canProgress = false;
                this.overwriteStepText(this.computedGroups[0].overwriteTextLeft),
                this.overwriteStepAudio(this.computedGroups[0].overwriteAudioLeft)
            }
        },
        overwriteStepText(text) {
            this.$emit("overwrite-step-text", text)
        },
        overwriteStepAudio(audio) {
            window.dispatchEvent(new CustomEvent('audio-playing'));
            this.$emit("overwrite-step-audio", audio)
        }
    },
    computed: {
        computedGroups() {
            return this.step.groups.filter(group => {
                if (this.step.groups.indexOf(group) === this.activeGroup) {
                    return group;
                }
            });
        },
        allGroupsDone() {
            let allDone = this.canProgress && (this.activeGroup + 1) === this.step.groups.length
            if(allDone) {
                this.$emit("step-completed", true, this.id)
            }
            return allDone;
        },
        getContinueButtonText() {
            return this.canProgress ? "Fortsæt" : `${this.activeGroup + 1} ud af ${this.step.groups.length}`;
        }
    }
})
Vue.component("CaseStepSortGroup", {
    props: ["tools", "imgDirectory"],
    template: `
        <div class="CaseStepSortGroup" :class="{'CaseStepSortGroup--2': tools.length === 2, 'CaseStepSortGroup--active': allAnswered}"> 
            <div v-for="(tool, i) in processedTools" :class="{'CaseStepSortGroup--correct': tool.correct === true, 'CaseStepSortGroup--incorrect': tool.correct === false}">
                <h6 v-html="tool.title"></h6>
                <div class="CaseStepSortGroup__imgwrapper">
                    <img :src="imgDirectory + tool.image.src">
                </div>
                <div class="CaseStepSortGroup__buttons">
                    <button @click="selectAnswer('GRØN', tool)" :class="{'CaseStepSortGroup__buttons--active': tool.selected === 'GRØN'}">GRØN</button>
                    <button @click="selectAnswer('RØD', tool)" :class="{'CaseStepSortGroup__buttons--active': tool.selected === 'RØD'}">RØD</button>
                </div>
            </div>


           
        </div>
    `,
    data() {
        return {
            processedTools: [],
            allAnswered: false
        }
    },
    created() {
        this.processTools();
    },
    methods: {
        processTools() {
            this.processedTools = this.tools.map(t => {
                t.selected = false;
                t.correct = null;
                return t;
            })
        },

        selectAnswer(answer, tool) {
            if (tool.selected === false) {
                tool.selected = answer;
                tool.correct = tool.selected.toLowerCase() == tool.buttons.toLowerCase();
                this.allAnswered = this.checkIfAllAnswered();
                this.$forceUpdate();
            }
        },
        checkIfAllAnswered() {
            return this.processedTools.filter(h => h.selected !== false).length === this.processedTools.length
        },
        checkIfAllCorrect() {
            return this.processedTools.filter(t => t.correct).length === this.processedTools.length;
        }
    },
    watch: {
        allAnswered: function (val) {
            if (val === true)
                this.$emit("group-completed", this.checkIfAllCorrect())
        },
        tools: function(val) {
            this.processTools();
        }
    }
})

/* HOTSPOTS*/
Vue.component("CaseStepHotspots", {
    props: ["step", "imgDirectory", "id"],
    template: `
        <div class="CaseStepHotspots" @click.self="closeHotspot">
            <div class="CaseStepHotspots__hotspot" v-for="hotspot in hotspots" :class="getHotspotClass(hotspot)" :style="getHotspotPosition(hotspot)" @click="selectHotspot(hotspot)"></div>

            <transition name="HotspotPopupAnimation">
                <aside class="CaseStepHotspots__popup" v-if="getCurrentHotspot !== undefined">
                    <div class="CaseStepHotspots__popup_close" @click="closeHotspot"></div>
                    <img :src="imgDirectory + getCurrentHotspot.image.src">
                    <h3 v-html="getCurrentHotspot.title"></h3>
                    <div class="CaseStepHotspots__popup_text" v-html="getCurrentHotspot.text"></div>
                    <TkReader v-if="getCurrentHotspot.textToSpeech !== null" :audio="getCurrentHotspot.textToSpeech"></TkReader>
                </aside>
            </transition>

            <button class="button__continue button" v-if="!allAnswered">
                <span v-html="getContinueButtonText"></span>
            </button>
        </div>
    `,
    data() {
        return {
            hotspots: [],
            currentHotspot: null,
            allAnswered: false,
            completed: 0
        }
    },
    created() {
        this.prepareHotpots();
        this.$forceUpdate();
    },
    methods: {
        prepareHotpots() {
            this.hotspots = this.step.hotspots.map((h, i) => {
                h.id = i;
                h.completed = false;
                return h;
            });

        },
        getHotspotPosition(hotspot) {
            return {
                left: hotspot.xPosition + 'px',
                top: hotspot.yPosition + 'px'
            }
        },
        selectHotspot(hotspot) {
            if (hotspot.id === this.currentHotspot) {
                this.currentHotspot = null;
            } else {
                this.currentHotspot = null;
                hotspot.completed = true;

                setTimeout(() => {
                    this.currentHotspot = hotspot.id;
                }, 1);
            }

            this.allAnswered = this.checkIfAllAnswered();
            this.$forceUpdate();
        },
        getHotspotClass(hotspot) {
            return {
                'CaseStepHotspots__hotspot--completed': hotspot.completed,
                'CaseStepHotspots__hotspot--open': hotspot.id === this.currentHotspot
            }
        },
        checkIfAllAnswered() {
            this.completed = this.hotspots.filter(h => h.completed).length;
            return this.completed === this.hotspots.length
        },
        closeHotspot() {
            this.currentHotspot = null;
        }
    },
    computed: {
        getCurrentHotspot() {
            return this.hotspots.find(hotspot => {
                if (hotspot.id === this.currentHotspot) {
                    return hotspot;
                }
            });
        },
        getContinueButtonText() {
            return `${this.completed} ud af ${this.hotspots.length}`;
        }
    },
    watch: {
        allAnswered: function (val) {
            if (val === true)
                this.$emit("step-completed", val, this.id)
        }
    }
})


/* FLIP CARDS */
Vue.component("CaseStepCards", {
    props: ["step", "imgDirectory", "id"],
    template: `
        <div class="CaseStepCards">
            <TkCard v-for="card in cards" class="size-tavlemoder card--disable-hover card--disable-remove" :class="getCardSubClass(card)" :card="{'id': card.id}" @cardFlipped="cardFlipped">
                <template v-slot:front >
                    <div class="card-face">
                        <img :src="imgDirectory + card.frontImage.src">
                        <h2 v-html="card.frontTitle"></h2>
                    </div>
                </template>
                <template v-slot:back>
                    <div class="card-face">
                        <h5 v-html="card.title"></h5>
                        <div class="card-face__text" v-html="card.text"></div>
                        <TkReader :audio="card.textToSpeech"></TkReader>
                    </div>
                </template>
            </TkCard>

            <button class="button__continue button" v-if="!allAnswered">
                <span v-html="getContinueButtonText"></span>
            </button>
        </div>
    `,
    data() {
        return {
            cards: [],
            allAnswered: false,
            flipped: 0
        }
    },
    created() {
        this.prepareCards();
    },
    methods: {
        prepareCards() {
            this.cards = this.step.cards.map((c, i) => {
                c.id = i;
                c.completed = false;
                return c;
            })
        },
        cardFlipped(id) {
            this.cards[id].completed = true;
            this.allAnswered = this.checkIfAllFlipped();
        },
        checkIfAllFlipped() {
            this.flipped = this.cards.filter(c => c.completed).length;
            return this.flipped === this.cards.length
        },
        getCardSubClass(card) {
            if(card.type)
                return `TkCard--${card.type}`;
        }
    },
    watch: {
        allAnswered: function (val) {
            if (val === true)
                this.$emit("step-completed", val, this.id)
        }
    },
    computed: {
        getContinueButtonText() {
            return `${this.flipped} ud af ${this.cards.length}`;
        }
    }
})

/* A step for a "completed" receipt for the user */
Vue.component("CaseStepCompleted", {
    props: ["step", "imgDirectory", "id"],
    template: `
        <div class="CaseStepCompleted">
            <img src="assets/img/ui/completed-w-circle.svg">
            <h3 v-html="step.completedText"></h3>
        </div>
    `,
    mounted() {
        this.completed();
    },
    methods: {
        completed() {
            this.$emit("step-completed", true, this.id)
        }
    }
})

/* None component(if no content assigned) */
Vue.component("CaseStepNone", {
    props: ["step", "imgDirectory", "id"],
    template: `
        <div class="CaseStepNone">
        </div>
    `,
    mounted() {
        this.completed();
    },
    methods: {
        completed() {
            this.$emit("step-completed", true, this.id)
        }
    }
})

touchKit.ComponentManager.register("Case", {
    singleton: true
});